function enhanceNakedFormSelectKeyboard(formItem) {
  const wrap = formItem.querySelector('.naked-form-select-wrap');
  if (!wrap) return;
  const toggle = wrap.querySelector('.toggle-dropdown');
  const listContainer = wrap.querySelector('.options-wrap');
  const list = listContainer && listContainer.querySelector('ul');
  const nativeSelect = wrap.querySelector('select');
  if (!toggle || !list || !nativeSelect) return;

  const items = [...list.querySelectorAll('li')];
  const isMultiple = nativeSelect.multiple;
  const listId = `naked-list-${Math.random().toString(36).slice(2, 9)}`;

  list.id = listId;
  list.setAttribute('role', 'listbox');
  if (isMultiple) list.setAttribute('aria-multiselectable', 'true');

  toggle.setAttribute('aria-haspopup', 'listbox');
  toggle.setAttribute('aria-expanded', wrap.classList.contains('open') ? 'true' : 'false');
  toggle.setAttribute('aria-controls', listId);
  if (nativeSelect.id) toggle.setAttribute('aria-labelledby', `${nativeSelect.id} ${listId}`);

  items.forEach((item, idx) => {
    item.setAttribute('role', 'option');
    item.setAttribute('tabindex', '-1');
    item.id = `${listId}-opt-${idx}`;
    item.setAttribute('aria-selected', item.classList.contains('selected') ? 'true' : 'false');
  });

  let activeIndex = Math.max(0, items.findIndex(item => item.classList.contains('selected')));
  let typeahead = '';
  let typeaheadTimer = null;

  function setActive(index, { focus = true } = {}) {
    if (index < 0 || index >= items.length) return;
    activeIndex = index;
    items.forEach(i => i.classList.remove('active'));
    const item = items[index];
    item.classList.add('active');
    toggle.setAttribute('aria-activedescendant', item.id);
    if (focus) item.focus({ preventScroll: false });
  }

  function isOpen() {
    return wrap.classList.contains('open');
  }

  function openList() {
    if (!isOpen()) toggle.click();
    toggle.setAttribute('aria-expanded', 'true');
    const startIndex = Math.max(0, items.findIndex(item => item.classList.contains('selected')));
    setActive(startIndex >= 0 ? startIndex : 0);
  }

  function closeList({ focusToggle = true } = {}) {
    if (isOpen()) toggle.click();
    toggle.setAttribute('aria-expanded', 'false');
    if (focusToggle) toggle.focus();
  }

  function selectItem(item) {
    item.click();
    items.forEach(i => i.setAttribute('aria-selected', i.classList.contains('selected') ? 'true' : 'false'));
  }

  function findByTypeahead(str) {
    const lower = str.toLowerCase();
    const start = activeIndex + 1;
    for (let i = 0; i < items.length; i++) {
      const idx = (start + i) % items.length;
      if (items[idx].textContent.trim().toLowerCase().startsWith(lower)) return idx;
    }
    return -1;
  }

  toggle.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Enter':
      case ' ':
        e.preventDefault();
        openList();
        break;
      case 'Escape':
        if (isOpen()) {
          e.preventDefault();
          closeList();
        }
        break;
    }
  });

  list.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setActive(Math.min(items.length - 1, activeIndex + 1));
        break;
      case 'ArrowUp':
        e.preventDefault();
        setActive(Math.max(0, activeIndex - 1));
        break;
      case 'Home':
        e.preventDefault();
        setActive(0);
        break;
      case 'End':
        e.preventDefault();
        setActive(items.length - 1);
        break;
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (items[activeIndex]) {
          selectItem(items[activeIndex]);
          if (!isMultiple) closeList();
        }
        break;
      case 'Escape':
        e.preventDefault();
        closeList();
        break;
      case 'Tab':
        closeList({ focusToggle: false });
        break;
      default:
        if (e.key.length === 1 && /\S/.test(e.key)) {
          typeahead += e.key;
          clearTimeout(typeaheadTimer);
          typeaheadTimer = setTimeout(() => { typeahead = ''; }, 500);
          const match = findByTypeahead(typeahead);
          if (match !== -1) setActive(match);
        }
    }
  });

  items.forEach((item) => {
    item.addEventListener('click', () => {
      items.forEach(i => i.setAttribute('aria-selected', i.classList.contains('selected') ? 'true' : 'false'));
    });
  });

  const observer = new MutationObserver(() => {
    const expanded = wrap.classList.contains('open');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
  observer.observe(wrap, { attributes: true, attributeFilter: ['class'] });
}

window.enhanceNakedFormSelectKeyboard = enhanceNakedFormSelectKeyboard;

class Forms extends DrupalBehavior {
  onContent(context) {

    once('formApplyNakedFormSelects', '.js-form-type-select', context).forEach((select) => {
      //Exclude keyword search filters, and any select that opts out via
      //js-no-naked-select (keeps the native <select> + its own styling).
      if ((select.parentNode.id == "edit-left") || (select.classList.contains('form-item-service')) || (select.classList.contains('js-no-naked-select'))) {
        return;
      }

      function openDropdown() {
        gsap.to(select.querySelector('.options-wrap'), {duration: .4, ease: 'power2.out', height: 'auto'});
      }

      function closeDropdown() {
        gsap.to(select.querySelector('.options-wrap'), {duration: .4, ease: 'power2.out', height: 0});
      }

      let options = {
        context: {
          value: select
        },
        events: {
          open: openDropdown,
          close: closeDropdown
        }
      };

      if (select.hasAttribute('data-keyword-search')) {
        options.keywordSearch = {
          on: true,
          placeholder: select.getAttribute('data-keyword-search-placeholder')
        }
      }

      nakedFormSelect('select', options);

      enhanceNakedFormSelectKeyboard(select);
    })

    once('formNakedFormSelectClickHandler', 'body', context).forEach((el) => {
      el.addEventListener('click', (e) => {
        let selectArr = [...document.querySelectorAll('[data-naked-select]')].filter(item => !item.contains(e.target));

        selectArr.forEach(select => {
          gsap.to(select.querySelector('.options-wrap'), {duration: .4, ease: 'power2.out', height: 0});
          select.classList.remove('open');
        })
      })
    })
  }
}

DrupalBehavior.register('summit_theme', 'forms', Forms);
